import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { scrollToSectionStart } from '../lib/scrollToSectionStart';
import { useScrollCueVisibility } from './useScrollCueVisibility';
import './ScrollCue.css';

export default function ScrollCue({
  sectionId,
  targetId = 'workspaces',
  label = 'See how it works',
  ariaLabel,
  variant = 'hero',
}) {
  const reduceMotion = useReducedMotion();
  const isSectionCue = variant === 'section';
  const visible = useScrollCueVisibility(sectionId);

  const handleClick = () => {
    scrollToSectionStart(targetId);
  };

  return (
    <motion.button
      type="button"
      className={`scroll-cue${isSectionCue ? ' scroll-cue--section' : ''}${
        visible ? '' : ' scroll-cue--concealed'
      }`}
      onClick={handleClick}
      aria-label={ariaLabel || label}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      initial={reduceMotion || isSectionCue ? false : { opacity: 0, y: -8 }}
      animate={{
        opacity: visible ? 1 : 0,
        y: visible ? 0 : 8,
      }}
      transition={{
        delay: isSectionCue || !visible ? 0 : 1.2,
        duration: reduceMotion ? 0 : 0.28,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <span className="scroll-cue-label">{label}</span>
      <motion.span
        className="scroll-cue-icon"
        animate={reduceMotion || !visible ? undefined : { y: [0, 6, 0] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
      >
        <ChevronDown size="1.25rem" aria-hidden />
      </motion.span>
    </motion.button>
  );
}
